export default __webpack_public_path__ + "3657a19fd15b082401c8c79d644a2747.png";